import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Employee } from 'src/app/models/Employee';

@Component({
    selector: 'app-employee-link-modal',
    templateUrl: './employee-link-modal.component.html',
    styleUrls: ['./employee-link-modal.component.scss'],
})
export class EmployeeLinkModalComponent implements OnInit {
    private subscriptions = new Subscription();

    public emitObject: EventEmitter<{ employee: Employee; price: number }> = new EventEmitter();

    @Input() data;
    @Input() isLoading = false;
    @Input() addItemFunction = undefined;

    formGroup: FormGroup;

    constructor(public activeModal: NgbActiveModal, private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            employee: '',
        });
    }

    onSubmit() {
        this.emitObject.emit({
            employee: this.formGroup.get('employee').value,
            price: 0,
        });
        this.activeModal.close();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
